import { IterableElement } from 'type-fest'

import { BASE_TOKEN_TICKERS } from './base'
import { BSC_TOKEN_TICKERS } from './bsc'
import { ETH_TOKEN_TICKERS } from './eth'
import { SOLANA_TOKEN_TICKERS } from './solana'
import { TRON_TOKEN_TICKERS } from './tron'
import { ARBITRUM_TOKEN_TICKERS } from './arbitrum'

export const CRYPTO_TOKENS_TICKES = [
  ...new Set([
    ...BSC_TOKEN_TICKERS,
    ...ETH_TOKEN_TICKERS,
    ...TRON_TOKEN_TICKERS,
    ...SOLANA_TOKEN_TICKERS,
    ...BASE_TOKEN_TICKERS,
    ...ARBITRUM_TOKEN_TICKERS
  ])
]

export type CryptoTokenTicker = IterableElement<typeof CRYPTO_TOKENS_TICKES>
